module.exports = __webpack_public_path__ + "img/icon-over.fc1db911.png";